import { createSelector } from "@ngrx/store";
import { EntityEstadosLaboratorioState, entityEstadosLaboratorioAdapter } from "./estados-laboratorio.state";
import { VistaUsuarioState, selectVistaUsuario } from "../../vista-usuario/vista-usuario.state";


const { selectEntities, selectAll } = entityEstadosLaboratorioAdapter.getSelectors();

export const getError = (state: EntityEstadosLaboratorioState): any => state.error;

export const getIsLoading = (state: EntityEstadosLaboratorioState): boolean =>
  state.isLoading;

export const selectEstadosLaboratorioState = createSelector(
  selectVistaUsuario,
  (state: VistaUsuarioState) => state.estadosLaboratorio
);

export const selectAllEstadoLaboratorio = createSelector(selectEstadosLaboratorioState, selectAll);
export const selectEntitiesEstadoLaboratorio = createSelector(
  selectEstadosLaboratorioState,
  selectEntities
);

// MemoizedSelector<object,any>
export const selectEstadoLaboratorioError = createSelector(
  selectEstadosLaboratorioState,
  getError
);

// MemoizedSelector<object,any>
export const selectEstadoLaboratorioIsLoading = createSelector(
  selectEstadosLaboratorioState,
  getIsLoading
);
